import script from "./TextEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TextEdit.vue?vue&type=script&setup=true&lang=js"

import "./TextEdit.vue?vue&type=style&index=0&id=3162dce9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3162dce9"]])

export default __exports__